import { ScholarshipInfoService } from "./../../../../../scholarship-management/src/lib/services/scholarshipinfo.service";
import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ModalActionsService } from "../../services/modal-actions.service";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  FormArray,
  Validators,
} from "@angular/forms";
import {
  ScholarshipPaymentDto,
  ScholarshipManagementDto,
  EpimsBankDetailDto,
  EpimsBankDto,
  CurrencyDto,
} from "@cradua/data";
import Swal from "sweetalert2";

@Component({
  selector: "app-modal",
  templateUrl: "./modal.component.html",
  styleUrls: ["./modal.component.css"],
})
export class ModalComponent implements OnInit {
  scholarshipPaymentForm: FormGroup;
  paymentInfo: any;
  scholarshipPayments: ScholarshipPaymentDto[];
  studentInfo: ScholarshipManagementDto;
  date = new Date();
  totalAmountPaid: number;
  bankDetails: EpimsBankDetailDto[];
  bankForm: FormGroup;
  control = new FormControl();
  selectedBankDetail: any;
  filteredDelete: Array<any> = [];
  banks: Array<EpimsBankDto> = [];
  currencies: Array<CurrencyDto> = [];
  loading = true;
  PostedBy = "Elvis";
  paymentReportInfo: any;
  constructor(
    public dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    // private modalService: ModalActionsService,
    private fb: FormBuilder,
    private studentInfoService: ScholarshipInfoService,
  ) {
    //console.log(modalData);
  }

  ngOnInit() {
    if (this.modalData.name === "create") {
      this.formValidation();
      this.bankDetails = this.modalData.bankDetails;
      this.currencies = this.modalData.currencies;
    } else if (this.modalData.name === "view") {
      this.bankDetails = this.modalData.bankDetails;
      this.paymentInfo = this.getStudentInfo(this.modalData.student);
      this.currencies = this.modalData.currencies;
      console.log("data ", this.paymentInfo);
    } else if (this.modalData.name === "report") {
      this.studentInfo = this.modalData.student;
      this.scholarshipPayments = this.modalData.scholarshipPayment;
      this.bankDetails = this.modalData.bankDetails;
      this.paymentReportInfo = this.getPaymentArray();
      this.banks = this.modalData.banks;
      this.currencies = this.modalData.currencies;
      this.totalAmountPaid = this.modalData.scholarshipPayment
        .map((item) => item.AmountPaid)
        .reduce((prev, next) => prev + next);
    } else if (this.modalData.name === "bankDetail") {
      this.studentInfo = this.modalData.student;
      this.bankDetails = this.modalData.bankDetails;
      this.banks = this.modalData.banks;
      this.bankForm = this.fb.group({ BankDetails: this.fb.array([]) });
      this.setBankDetail();
    }
  }

  getPaymentArray() {
    return this.modalData.scholarshipPayment.map((item) => {
      return {
        PaymentDescription: item.PaymentDescription,
        AmountPaid: item.AmountPaid,
        DatePaid: item.DatePaid,
        CurrencyId: this.getCurrencyCode(item.CurrencyId),
        BankDetailInfo: this.getBankDetail(item.BankName),
      };
    });
  }

  getBankDetail(id) {
    const bankDetail: EpimsBankDetailDto = this.modalData.bankDetails.find(
      (item) => item.id === id,
    );
    let bankDetailData = {
      BankName: this.getBankName(bankDetail.BankName),
      SortCode: bankDetail.SortCode,
      BeneficiaryAccountName: bankDetail.BeneficiaryAccountName,
      BeneficiaryAccountNumber: bankDetail.BeneficiaryAccountNumber,
      Branch: bankDetail.Branch,
      Remark: bankDetail.Remark,
      BVN: bankDetail.BVN,
      StudentId: bankDetail.StudentId,
      id: bankDetail.id,
    };

    // console.log('bank data ', bankDetailData);
    return bankDetailData;
  }

  getStudentInfo(info) {
    let data = {
      studentInfo: info,
      CurrencyId: this.getCurrencyCode(info.CurrencyId),
      studentBankDetail: this.getBankDetailObject(info.BankName),
    };
    return data;
  }

  getBankDetailObject(id: string): EpimsBankDetailDto {
    return this.modalData.bankDetails.find((item) => item.id === id);
  }

  getCurrencyCode(id) {
    return this.modalData.currencies.find((item) => item.id === id)
      .CurrencyCode;
  }

  formValidation() {
    this.scholarshipPaymentForm = this.fb.group({
      ScholarshipAwardNo: [
        { value: this.modalData.student.ScholarshipAwardNo, disabled: true },
      ],
      StudentName: [
        {
          value: this.modalData.student.BeneficarySurname +
            " " +
            this.modalData.student.BeneficaryFirstname +
            " " +
            this.modalData.student.BeneficaryOthername,
          disabled: true,
        },
      ],
      // AccountNo: [100],
      CurrencyId: [""],
      AccountName: [""],
      BankName: [""],
      Branch: [""],
      AmountPaid: [],
      StudentId: [""],
      DatePaid: [""],
      PaymentMode: [""],
      PaymentDescription: [""],
      BankId: [""],
    });
  }

  // form = new FormGroup({
  //   first: new FormControl({value: 'Nancy', disabled: true}, Validators.required),
  //   last: new FormControl('Drew', Validators.required)
  // });

  /* Handle form errors in Angular 8 */
  public errorHandling = (control: string, error: string) => {
    return this.scholarshipPaymentForm.controls[control].hasError(error);
  };

  // When the user clicks the action button, the modal calls the service\
  // responsible for executing the action for this modal (depending on\
  // the name passed to `modalData`). After that, it closes the modal
  actionFunction() {
    // this.modalService.modalAction(this.modalData);
    this.closeModal();
  }

  getBankName(value) {
    return this.modalData.banks.find((item) => item.id === value).BankName;
  }

  getStateName(value) {
    return this.studentInfoService.stateName(this.modalData.states, value);
  }

  getLgaName(value) {
    return this.studentInfoService.lgaName(this.modalData.lgas, value);
  }

  getCommunityName(value) {
    return this.studentInfoService.communityName(
      this.modalData.communities,
      value,
    );
  }

  getScholarshipCategoryName(value) {
    return this.studentInfoService.scholarshipCategoryName(
      this.modalData.scholarshipCategories,
      value,
    );
  }

  getScholarshipTypeName(value) {
    return this.studentInfoService.scholarshipTypeName(
      this.modalData.scholarshipTypes,
      value,
    );
  }

  getGenderName(value) {
    return this.studentInfoService.genderName(this.modalData.genders, value);
  }

  getCourseOfStudyName(value) {
    return this.studentInfoService.courseOfStudyName(
      this.modalData.courseOfStudies,
      value,
    );
  }

  onSubmit(value) {
    console.log("submittttt ", value);
    value.StudentName = this.modalData.student.BeneficarySurname +
      " " +
      this.modalData.student.BeneficaryFirstname +
      " " +
      this.modalData.student.BeneficaryOthername;
    value.ScholarshipAwardNo = this.modalData.student.ScholarshipAwardNo;
    value.StudentId = this.modalData.student.id;
    value.AmountPaid = +value.AmountPaid;
    value.PostedBy = this.PostedBy;
    // this.closeModal();
    this.dialogRef.close(value);
  }

  openBankDetail() {
    this.dialogRef.close("bankDetail");
  }

  // If the user clicks the cancel button a.k.a. the go back button, then\
  // just close the modal
  closeModal() {
    this.dialogRef.close();
  }

  clickMe(value) {
    //	console.log('click ', value);
  }

  // method to display banks
  setBankDetail() {
    const control = this.bankForm.controls.BankDetails as FormArray;
    this.bankDetails.forEach((item) => {
      control.push(
        this.fb.group({
          BankName: item.BankName,
          SortCode: item.SortCode,
          BeneficiaryAccountName: item.BeneficiaryAccountName,
          BeneficiaryAccountNumber: item.BeneficiaryAccountNumber,
          Branch: item.Branch,
          Remark: item.Remark,
          BVN: item.BVN,
          StudentId: item.StudentId,
          id: item.id,
        }),
      );
    });
  }

  // method to add Bank
  addBankDetail() {
    const control = this.bankForm.controls.BankDetails as FormArray;
    control.insert(
      0,
      this.fb.group({
        BankName: ["", Validators.required],
        SortCode: ["", Validators.required],
        BeneficiaryAccountName: ["", Validators.required],
        BeneficiaryAccountNumber: ["", Validators.required],
        Branch: ["", Validators.required],
        Remark: [""],
        BVN: [""],
        StudentId: [this.studentInfo.id],
        id: null,
      }),
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete bank from arrary list
  deleteBankDetail(index, value) {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this imaginary file!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        const control = this.bankForm.controls.BankDetails as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.bankDetails.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.bankDetails[i].id);
            }
          }
        }
        Swal.fire(
          "Deleted!",
          "Your imaginary file has been deleted.",
          "success",
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "Your imaginary file is safe :)", "error");
      }
    });
  }

  onSubmitBankDetail(form: any) {
    let data = {
      formValue: null,
      filteredDelete: null,
      type: null,
    };
    if (this.filteredDelete.length !== 0) {
      data.filteredDelete = this.filteredDelete;
    }
    (data.formValue = form), (data.type = "save");

    //console.log(data)
    this.dialogRef.close(data);
  }
}
